import { IUpdateCentroCustoUseCase } from "../../../presentation/useCases/update/update_centro_custo_use_case";
import { CentroCusto } from "../../models/centro_custo";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateCentroCustoUseCase
 */

export class UpdateCentroCustoUseCase implements IUpdateCentroCustoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async updateCentroCusto(
    idCentroCusto: number,
    status: number,
    codigo: string,
    descricao: string,
    bdi?: number | null,
    bdi2?: number | null,
    numeroCno?: string,
    obsCentroCusto?: string): Promise<CentroCusto> {
    const result = this.repository.updateCentroCusto(
      idCentroCusto = idCentroCusto,
      status = status,
      codigo = codigo,
      descricao = descricao,
      bdi = bdi,
      bdi2 = bdi2,
      numeroCno = numeroCno,
      obsCentroCusto = obsCentroCusto
    )
    return result;
  }

}
